import React, {useRef, useState, useEffect} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import Language from 'helpers/Language';

import Languages from 'components/structure/parts/Languages';
import Logo from 'assets/images/logo.png';
import Pages from 'configs/pages';
import useConfig from 'hooks/useConfig';
import useSession from 'hooks/useSession';
import Urls from 'configs/urls';
import useOutsideAlerter from 'hooks/useOutsideAlerter';

function Header() {
	let location = useLocation();
	const {t} = useTranslation();
	const [openMenuUser, setOpenMenuUser] = useState(false);
	const wrapperRef = useRef(null);
	const [activeMenu, setActiveMenu] = useState(false);

	useEffect(() => {
		if (location.pathname.indexOf('planner') !== -1) {
			setActiveMenu(1);
		}
		if (location.pathname === Pages.sessions.getUrl()) {
			setActiveMenu(2);
		}
	}, [location]);

	useOutsideAlerter(wrapperRef, () => {
		setOpenMenuUser(false);
	});

	const toogleMenuUser = () => {
		setOpenMenuUser(!openMenuUser)
	};

	const {
		user
	} = useConfig();

	const {
		session
	} = useSession();

	return (
		<div id="nav" className="nav-container d-flex">
			<div className="nav-content d-flex">
				<div className="logo position-relative">
					<img src={Logo} alt="logo" />
				</div>

				<div className="menu-container flex-grow-1">

					<ul id="menu" className="menu show">
						<li className="dropdown">
							<a href={'/' + Language.getUrlLanguage() + '/'} className="dropdown-toggle"
							   data-bs-toggle="dropdown">
								<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2"
								     fill="none" strokeLinecap="round" strokeLinejoin="round" className="cs-icon icon">
									<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
									<polyline points="9 22 9 12 15 12 15 22"></polyline>
								</svg>
								<span className="label">{t("Menu.home")}</span>
							</a>
						</li>
						<li className="dropdown">
							<Link to={Pages.planner.getUrl()} className={activeMenu === 1 ? 'active' : ''}>
								<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2"
								     fill="none" strokeLinecap="round" strokeLinejoin="round"
								     className="cs-icon icon">
									<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
									<line x1="3" y1="9" x2="21" y2="9"></line>
									<line x1="9" y1="21" x2="9" y2="9"></line>
								</svg>
								<span className="label">{t("Menu.planner")}</span>
							</Link>
						</li>
						<li className="dropdown">
							<Link to={Pages.sessions.getUrl()} className={activeMenu === 2 ? 'active' : ''}>
								<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2"
								     fill="none" strokeLinecap="round" strokeLinejoin="round" className="cs-icon icon">
									<path
										d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
								</svg>
								<span className="label">{t("Menu.projects")}</span>
							</Link>
						</li>
					</ul>
				</div>

				<div className="container-left">
					<Languages />

					<div className="user-container d-flex"
					     ref={wrapperRef}
					     onMouseEnter={toogleMenuUser}
					     onMouseLeave={toogleMenuUser}
					>
						{user.anonym && (
							<a href={Urls.baseLogin.replace(':sessionId', session !== false ? session : '')}
							   className="d-flex user position-relative"
							   data-bs-toggle="dropdown"
							   aria-haspopup="true"
							   aria-expanded="false">
								<div className="name">
									{t('Header.login')}
								</div>
							</a>
						)}
						{user.anonym === false && (
							<div
								className="d-flex user position-relative"
								data-bs-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false">
								<div className="name">
									<span>{user.firstname} </span>
									<span>{user.lastname}</span>
								</div>
							</div>
						)}

						{user.anonym !== true && (
							<div
								className={'dropdown-menu dropdown-menu-end user-menu wide' + (openMenuUser ? ' show' : '')}>
								<div className="row mb-3 ms-0 me-0">
									<div className="col-12 ps-1 mb-2">
										<div className="text-extra-small text-primary">{t("Menu.account")}</div>
									</div>
									<div className="col-6 ps-1 pe-1">
										<ul className="list-unstyled">
											{/*<li>
											<a href="#">User Info</a>
										</li>*/}
											<li>
												<a href={'/' + Language.getUrlLanguage() + '/logout'}>{t("Menu.logout")}</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="nav-shadow"></div>
		</div>
	);
}

export default Header;
/*

		<header style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
			{t('Header.title')}
			<ColorSelector />
			<ModalSetting />
		</header>
 */
